import React from 'react';
import { Box, Grid, Typography } from "@mui/material";
import _ from "lodash";
import { useUser } from '../../../../../contexts/user.context';
import useAppInfo from '../../../../../hooks/appInfo.hook';
import Warnings from "../../../../../components/publish/Warnings";
import MissingDataCard from "../../../../../components/publish/MissingDataCard";
import PublishButton from "../../../../../components/publish/PublishButton";
import { storeStatus } from '../../../../../utils/constants';

export default function PublishContent({ blocked }) {
  const { appInfo } = useAppInfo();
  const { user } = useUser();

  const isDisabled = (appInfo?.storeStatus !== storeStatus.ACTIVE) || blocked;

  const publishStatus = appInfo.androidPublishStatus;
  const downloadUrl = appInfo.androidDownloadUrl;

  function isMissingData() {
    return (
      _.isEmpty(user?.store?.title) ||
      _.isEmpty(user?.store?.shortDescription) ||
      _.isEmpty(user?.store?.description) ||
      _.isEmpty(user?.store?.privacyPolicyUrl) ||
      _.isEmpty(user?.store?.keywords) ||
      _.isEmpty(user?.store?.launchScreenUrl) ||
      _.isEmpty(user?.store?.iconUrl) ||
      _.isEmpty(user?.store?.featureGraphicUrl)
    )
  }

  return (
    <Box>
      {['pending_listing_creation', 'publishing'].includes(appInfo?.androidPublishStatus)
        ? (
          <Typography variant="body1">
            Sua solicitação de publicação foi enviada.
          </Typography>
        )
        : (
          <Box>
            {isMissingData()
              ? (
                <Box paddingInline={2} paddingTop={2}>
                  <MissingDataCard />
                </Box>
              )
              : (
                <Box paddingInline={2}>
                  <Typography align="justify" variant="body1" sx={{ mb: 2 }}>
                    O próximo passo é solicitar a <strong>publicação do seu aplicativo Android</strong>.
                  </Typography>

                  <Typography align="justify" variant="body1" sx={{ mb: 3 }}>
                    <strong>Importante lembrar:</strong>
                  </Typography>

                  <Warnings deadlineInDays={20} downloadUrl={downloadUrl} platformName="Android" publishStatus={publishStatus} />

                  {(publishStatus == 'first_publish_pending' || publishStatus == 'pending_update') && !isMissingData() &&
                    <PublishButton platform="android" disabled={isDisabled} />
                  }

                  {blocked &&
                    <Box display='flex' justifyContent='center' marginTop={2} width='100%'>
                      <Typography variant="body1" fontWeight='bold' marginTop={1}>
                        Finalize a etapa anterior para solicitar a publicação
                      </Typography>
                    </Box>
                  }
                </Box>
              )
            }
          </Box>
        )
      }
    </Box>
  )
}